import script from "./AttachmentImage.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentImage.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentImage.vue?vue&type=style&index=0&id=260f2401&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260f2401"]])

export default __exports__